import React from 'react';
import { Button, Box } from '@mui/material';
import tableLabels from '../constants/tableLabels';

export default function ExpandableButtons({ domain, selectedTable, onTableSelect }) {
  const buttons = tableLabels[domain] || [];

  const handleClick = (table) => {
    if (table !== selectedTable) {
      onTableSelect(table);
    }
    // else do nothing, so it won't collapse
  };

  return (
<Box
  sx={{
    display: 'flex',
    flexWrap: 'nowrap',
    overflowX: 'auto',
    gap: 1,                      // ← Reduce gap
    padding: 1,                  // ← Reduce padding
    width: '100%',
    minHeight: '50px',           // ← ADD fixed height
    maxHeight: '50px',           // ← ADD fixed height
    borderRadius: 2,
    justifyContent: 'center',
    alignItems: 'center',        // ← ADD this
  }}
>
      {buttons.map((btn, index) => {
        const isExpanded = selectedTable === btn.full;

        return (
          <Button
            key={index}
            onClick={() => handleClick(btn.full)}
            variant={isExpanded ? 'contained' : 'outlined'}
            color={isExpanded ? 'primary' : 'secondary'}
            sx={{
                textTransform: 'none',
                minWidth: '50px',              // ← Smaller
                maxWidth: '150px',             // ← Smaller
                paddingX: 1,                   // ← Less padding
                paddingY: 0.5,                 // ← Less padding
                height: '32px',                // ← Fixed smaller height
                fontWeight: 'normal',          // ← Less bold
                fontSize: '12px',              // ← Smaller font
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                transition: 'all 0.3s ease',
                backgroundColor: isExpanded ? (t)=>t.palette.text.primary : 'transparent',  // ← Filled when active
                color: isExpanded ? (t)=>t.palette.background.default : (t)=>t.palette.text.primary,               // ← Contrasting text when active
                border: (t) => `1px solid ${t.palette.text.primary}`,                        // ← Border follows the theme
                  '&:hover': {
                      backgroundColor: (t) =>
                        isExpanded
                          ? t.palette.text.secondary
                          : t.palette.action.hover,
                      color: (t) =>
                        isExpanded
                          ? t.palette.background.default
                          : t.palette.text.primary,
                      }
              }}
          >
            {isExpanded ? (btn.label || btn.full) : btn.short}
          </Button>
        );
      })}
    </Box>
  );
}
